import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=ad54384a&scoped=true"
import script from "./NumberView.vue?vue&type=script&lang=js"
export * from "./NumberView.vue?vue&type=script&lang=js"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=ad54384a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad54384a",
  null
  
)

export default component.exports